import { StyleSheet } from "react-native";
import LottieView from "lottie-react-native";

function Active() {
  return (
    <LottieView
      autoPlay
      loop={true}
      style={styles.lottie}
      source={{ ...require("../../../../assets/lottie/progress/active_progress.json") }}
    />
  );
}

const styles = StyleSheet.create({
  lottie: {
    width: 35,
    height: 35,
  },
});

export default Active;
